import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardSubtitle, CardText, CardTitle, Col, Row } from 'reactstrap';

import * as _ from 'lodash';
import * as moment from 'moment';

import './jobs.scss';
import JobDetail from './job-detail/job-detail.component';

interface JobsComponentProps {
  jobs: any[];
}

interface JobsComponentState {
  selectedJob: any;
}

class JobsComponent extends Component<JobsComponentProps, JobsComponentState> {

  constructor(props: any) {
    super(props);

    this.renderJob = this.renderJob.bind(this);
    this.readMoreHandler = this.readMoreHandler.bind(this);
    this.modalClosedHandler = this.modalClosedHandler.bind(this);

    this.state = {
      selectedJob: null,
    };
  }

  render() {
    const {jobs} = this.props;
    const {selectedJob} = this.state;

    return (
        <article role="projects" id="experience">
          <h2>Experience</h2>
          <Row className="row-eq-height">
            {jobs.map(this.renderJob)}
          </Row>
          <JobDetail job={selectedJob}
                     isOpen={!!selectedJob}
                     onClosed={this.modalClosedHandler}/>
        </article>
    );
  }

  renderJob(job: any, index: number) {
    const startDate = this.formatDate(job.startDate);
    const endDate = this.formatDate(job.endDate, 'Present');
    return (
        <Col md={4} sm={6} key={`job-${index}`} className="mb-3">
          <Card>
            <CardBody className="d-flex flex-column">
              <header>
                <i className={`${job.icon || 'fa fa-code'}`}/>
                <CardTitle>{job.position}</CardTitle>
                <CardSubtitle>
                  <a href={job.website} target="_blank">{job.company}</a>
                </CardSubtitle>
              </header>
              <article>
                <CardSubtitle>{startDate} - {endDate}</CardSubtitle>
                <CardText dangerouslySetInnerHTML={{__html: job.summary}}/>
              </article>
              <footer className="align-self-center justify-content-end">
                {job.projects && <Button onClick={() => this.readMoreHandler(job)}>Read more</Button>}
              </footer>
            </CardBody>
          </Card>
        </Col>
    );
  }

  readMoreHandler(job: any) {
    this.setState({selectedJob: job});
  }

  modalClosedHandler() {
    this.setState({selectedJob: null});
  }

  private formatDate(date: moment.Moment | null | undefined, or: string = '') {
    return date ? date.format('MMMM YYYY') : or;
  }
}

const mapStateToProps = (state: any): JobsComponentProps => {
  return {
    jobs: _.get(state.cv, 'work.entries', [])
           .filter((it: any) => !it.hide)
           .map((it: any) => {
             if (it.startDate) {
               it.startDate = moment(it.startDate);
             }
             if (it.endDate) {
               it.endDate = moment(it.endDate);
             }
             return it;
           })
  };
};

export default connect(mapStateToProps, null)(JobsComponent);



// WEBPACK FOOTER //
// ./src/components/jobs/jobs.component.tsx